import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@mui/material/Avatar';
import { makeStyles } from 'src/makeStyles';

import { colors, fontSize } from '../../constants/styleConstants';

const useStyles = makeStyles()(theme => ({
  icon: {
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 30,
  },
  iconText: {
    backgroundColor: colors.background.lightGrey,
    color: colors.darkText,
    fontSize: fontSize.medium,
    width: theme.spacing(6),
    height: theme.spacing(6),
    [theme.breakpoints.down('md')]: {
      width: theme.spacing(5),
      height: theme.spacing(5),
      fontSize: fontSize.smallTitle,
    },
  },
}));

const InitialsNameGenerator = ({ userName, className }) => {
  const { classes, cx } = useStyles();
  const nameInitials = str =>
    str
      ?.split(' ')
      .map(c => c.charAt(0).toUpperCase())
      .join('')
      .concat(str.charAt(1).toUpperCase())
      .substring(0, 2);

  return userName ? (
    <div className={classes.icon}>
      <Avatar className={cx(classes.iconText, className)}>{nameInitials(userName)}</Avatar>
    </div>
  ) : null;
};

InitialsNameGenerator.propTypes = {
  userName: PropTypes.string,
};

export default InitialsNameGenerator;
